import React from 'react';
import { Pressable, Icon, Spinner } from '@gluestack-ui/themed';

const FieldLabelAction = ({ labelAction }) => {
  const [isRunning, setRunning] = React.useState(labelAction?.isLoading || false);

  if (!labelAction) return null;

  if (labelAction?.component) {
    return labelAction.component;
  }

  const handlePress = async () => {
    if (!isRunning) {
      setRunning(true);
      await labelAction.action();
      setRunning(false);
    }
  };

  if (isRunning || labelAction.isLoading) {
    return <Spinner ml="$2" size={10} />;
  }

  if (labelAction.enabled === false) {
    if (!labelAction.icon) return null;
    return <Icon ml="$2" size={labelAction.iconSize || 10} as={labelAction.icon} color="$textLight300" />;
  }

  if (!labelAction.icon || !labelAction.action) return null;

  return (
    <Pressable onPress={handlePress}>
      <Icon ml="$2" size={labelAction.iconSize || 10} as={labelAction.icon} color="$blue500" />
    </Pressable>
  );
};

export default FieldLabelAction;
